<template>
	<div class="transaction-form pay-form-wrapper card-payment-bg">
		<div class="form-bar" id="#payment-form">
			<div class="no-gutters my-2">
				<div v-show="stripeReady" class="payment-element-wrapper" :id="paymentElementId"></div>
				<div v-if="!stripeReady" style="height: 125px" class="d-flex justify-center align-items">
					<HollowDotsSpinner
						class="d-flex align-items-center"
						:animation-duration="1000"
						:dot-size="14"
						:dots-num="3"
						color="var(--stan-primary-primary-color)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import { UUID } from '~/store/modules/Global.js'

	// TODO: add placeholder texts
	export default {
		name: 'StripePaymentInput',
		props: {
			stripe: { type: Object },
			showWallets: { type: Boolean, default: false },
		},
		mounted() {
			this.grecaptcha = window.grecaptcha
			this.createPaymentElement()
		},
		computed: {
			paymentElementId() {
				return `payment-element-${UUID()}`
			},
			elementAppearance() {
				// https://docs.stripe.com/elements/appearance-api
				return {
					theme: 'stripe',
					labels: 'floating',
					variables: {
						fontSizeBase: '14px',
						fontFamily: '"Inter", sans-serif',
						focusBoxShadow: 'transparent',
						colorPrimary: this.cssColor('--stan-primary-primary-color'),
						colorBackground: this.cssColor('--stan-light-background-color'),
						colorText: this.cssColor('--stan-text-dark-color'),
						colorDanger: this.cssColor('--stan-text-negative-color'),
						colorTextSecondary: this.cssColor('--stan-text-light-color'),
						colorTextPlaceholder: this.cssColor('--stan-text-light-color'),
						borderRadius: '12px',
						spacingUnit: '3px',
						fontSmooth: 'always',
					},
				}
			},
		},
		data() {
			return {
				elements: null,
				stripeReady: false,
			}
		},
		methods: {
			cssColor(variable) {
				return getComputedStyle(document.documentElement)
					.getPropertyValue(variable)
					.trim()
			},
			createPaymentElement() {
				const elementsOptions = {
					mode: 'setup',
					currency: 'usd', // this.currency.toLowerCase(),
					paymentMethodCreation: 'manual',
					paymentMethodTypes: ['card'],
					loader: 'auto',
					setupFutureUsage: 'off_session',
					appearance: this.elementAppearance,
				}

				// https://docs.stripe.com/js/element/payment_element
				this.elements = this.stripe.elements(elementsOptions)

				const paymentElement = this.elements.create('payment', {
					layout: 'tabs',
					wallets: {
						applePay: this.showWallets ? 'auto' : 'never',
						googlePay: this.showWallets ? 'auto' : 'never',
						link: 'auto',
					},
					fields: {
						billingDetails: {
							address: 'if_required',
							name: 'never',
							email: 'never',
						},
					},
					terms: { card: 'never', applePay: 'never', googlePay: 'never' },
				})

				paymentElement.mount(`#${this.paymentElementId}`)
				paymentElement.on('ready', () => {
					this.stripeReady = true
				})
			},
			async createPaymentMethod(stripeCustomerId, fullName, email) {
				let result = {}

				// Handles 3DS / Apple pay - Needs to be done first, since apple pay must be `near` the click event
				result = await this.elements.submit()

				// Error likely means they exited there google pay / apple pay setup
				if (!result.error) {
					const token = await this.grecaptcha.enterprise.execute(this.$configSettings.captchaSiteKey, {
						action: 'CreateSetupIntent',
					})

					const setupIntentPayload = {
						token,
						customer_id: stripeCustomerId,
					}

					const response = await axios.post('/v1/stripe/create-setup-intent', setupIntentPayload)
					const secret = response.data?.secret

					try {
						result = await this.stripe.confirmSetup({
							elements: this.elements,
							clientSecret: secret,
							confirmParams: {
								return_url: window.location.href,
								payment_method_data: {
									billing_details: {
										name: fullName,
										email,
									},
								},
							},
							redirect: 'if_required',
						})
					} catch (error) {
						console.error(error)
						result.error = error
					}
				}
				if (result.error) {
					this.$stanNotify({
						type: 'error',
						title: 'There was an issue',
						text: 'We were unable to validate your payment method. Please try another card.',
					})
					this.$logError(result.error)
					return null
				}
				return result.setupIntent.payment_method
			},
		},
	}
</script>
<style lang="scss">
	#payment-form {
		min-width: 310px;
		@media (max-width: 460px) {
			min-width: inherit;
		}
		min-width: 307px;
	}
</style>
